import styled from "styled-components";

export const MascotasTableContainer = styled.div`
  .fullWidth {
    width: 95%;
  }
  .halfWidth {
    width: 47%;
  }
  .oneThirdWidth {
    width: 30%;
  }
  .twoThirdWidth {
    width: 65%;
  }

  .coverage-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 20px;
  }

  .flex-no-wrap {
    flex-wrap: nowrap;
  }

  .checkbox-container {
    p {
      white-space: normal;
    }
  }
`;
